import React from "react";
import { Field } from "redux-form";
import { useNavigate } from "react-router-dom";
import { required, email } from "redux-form-validators";

import { scrollToTop } from "../../../../helpers/animation";
import { Button, Checkbox, Input } from "../../../../components/Field";
import Link from "../../../../components/Link";
import Text from "../../../../components/Text";
import AsyncGet from "../../../../components/AsyncGet";
import AsyncForm from "../../../../components/AsyncForm";
import PlanList from "../../../../components/MemberForm/PlanList";

import style from "../style.module.css";
import { get } from "lodash";

export default function PersonalDetails({ nextStep, personalDetails = {}, setPersonalDetails, urlHash, setPlanId, setPlanType }) {
    const navigate = useNavigate();
    return (
        <div className={style.personalDetails}>
            <AsyncGet
                url="/account/verify-reactivehash"
                permissionText="Verify Reactivehash"
                loadOnMount={true}
                method="post"
                paramsData={{ reactive_hash: urlHash }}
                render={({ data }) => {
                    if (data && data.has_membership === true) {
                        navigate('/profile');
                    }
                    else if (data && data.has_membership === false) {
                        return (
                            <AsyncForm
                                id="reactivationstep01"
                                url="/account/reactive-member"
                                permission="Reactive Member"
                                type="update"
                                showToastOnSuccess={false}
                                hasGetAction={false}
                                onSave={({ data }) => {
                                    setPersonalDetails(data);
                                    nextStep('ConfirmDetails');
                                    scrollToTop();
                                }}
                                initialValues={{
                                    first_name: personalDetails.first_name,
                                    surname: personalDetails.surname,
                                    email: personalDetails.email,
                                    plan_id: personalDetails.membershipPlanId
                                }}
                                render={({ fetching, formValues }) => {
                                    return (
                                        <div className={style.form}>
                                            <div className={style.formRow}>
                                                <Text className="formTitle" text="CHoose a Membership plan" />
                                                <Text className="formSubTitle" text="Select membership type*" />
                                            </div>
                                            <div className={style.formRow}>
                                                <PlanList
                                                    freePlan={false}
                                                    setPlanId={setPlanId}
                                                    setPlanType={setPlanType}
                                                />
                                            </div>
                                            <div className={style.formRow}>
                                                <Text className="formTitle" text="enter personal DETAILS" />
                                            </div>
                                            <div className={style.formRow}>
                                                <Field
                                                    name="first_name"
                                                    component={Input}
                                                    validate={required()}
                                                    required={true}
                                                    placeholder="Enter your first name"
                                                    label="First name"
                                                />
                                            </div>
                                            <div className={style.formRow}>
                                                <Field
                                                    name="surname"
                                                    component={Input}
                                                    validate={required()}
                                                    label="Surname"
                                                    required={true}
                                                    placeholder="Enter your surname"
                                                />
                                            </div>
                                            <div className={`${style.formRow}`}>
                                                <Field
                                                    name="email"
                                                    component={Input}
                                                    validate={[required(), email()]}
                                                    label="Email address"
                                                    required={true}
                                                    placeholder="Enter email address"
                                                />
                                            </div>
                                            <div className={`${style.formRow} ${style.checkBoxRow}`}>
                                                <Field
                                                    name="terms"
                                                    component={Checkbox}
                                                    checkValue={1}
                                                    validate={required()}
                                                    link="terms-conditions"
                                                    label="I agree to"
                                                />
                                                <Link
                                                    className={style.termsLink}
                                                    target="_blank"
                                                    to={"terms-conditions"}
                                                >
                                                    {"terms & conditions"}
                                                </Link>*
                                            </div>
                                            <div className={`${style.formRow} ${style.formSubmit}`}>
                                                <Button
                                                    disabled={get(formValues, 'plan_id', "") ? false : true}
                                                    submit={true}
                                                    fetching={fetching}
                                                    label="NEXT"
                                                />
                                            </div>
                                        </div>
                                    )
                                }}
                            />
                        );
                    }
                    else if (data && data.has_membership !== false && data.has_membership !== true) {
                        navigate('/home');
                    }
                }}
            />
        </div>
    )
}